export default "__VITE_ASSET__DtxOpP_4__"